module.exports = __webpack_public_path__ + "img/icomoon.3d7b40df.svg";